<div class="circle"
     (click)="selectIcon(); $event.stopPropagation();"
     [ngClass]="{ opaque: !icon.highlighted }"
     [style.background-color]="color || '#ccc'">
  <i class="{{'fa ' + icon.code}}" aria-hidden="true"></i>
</div>
